"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBoxShadow = void 0;
var _constants = require("../constants");
const getBoxShadow = (background, theme) => _constants.WHITE_COLORS.includes(background) ? theme.palette.blueGrey[100] : theme.palette.common.white;
exports.getBoxShadow = getBoxShadow;
//# sourceMappingURL=getBoxShadow.js.map